import type { PayloadAction } from '@luna/state';
import { createSharedSlice } from '@luna/state';

export const useCurrentStepId = createSharedSlice({
    name: 'focusPageWithStepper',
    initialState: { currentStepId: '' },
    reducers: {
        setCurrentStepId(state, action: PayloadAction<string>) {
            state.currentStepId = action.payload || '';
        },
        resetCurrentStepId(state) {
            state.currentStepId = '';
        },
    },
});
